import React, { useEffect, useState } from 'react';
import { Wallet, Maximize2, CheckCircle2 } from 'lucide-react';
import ContaPagarTotal from './ContaPagarTotal';

function StatBox({ title, icon: Icon, color, border, principal, secundario, saldoPagar,percentual, onExpand }) {
  return (


    <div className={`relative bg-[#161b22] border-l-4 ${border} p-5 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      <button
        onClick={onExpand}
        className="absolute top-3 right-3 text-gray-600 hover:text-yellow-500 transition-colors z-20"
      >
        <Maximize2 size={18} />
      </button>

      <div className={`flex items-center gap-2 mb-6 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={14} /> <span>{title}</span>
      </div>

      <div className="flex justify-between items-end mb-4">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">A Pagar (Mês)</p>
          <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">
            R$ {Number(principal).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>

        <div className="relative w-16 h-16 rotate-[-90deg]">
          <svg className="w-full h-full">
            <circle cx="32" cy="32" r="28" stroke="#0d1117" strokeWidth="4" fill="transparent" />
            <circle
              cx="32" cy="32" r="28" stroke="currentColor"
              className="text-green-500 shadow-[0_0_8px_#22c55e]"
              strokeWidth="4" fill="transparent"
              strokeDasharray={175.9}
              strokeDashoffset={175.9 - (175.9 * percentual) / 100}
              strokeLinecap="round"
            />
          </svg>
          <div className="absolute inset-0 flex items-center justify-center rotate-90">
            <span className="text-yellow-500 font-mono text-xs font-black">{percentual}%</span>
          </div>
        </div>
      </div>
      <div className="flex justify-between items-end mb-4">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase italic">Quitados</p>
          <p className="text-green-400 font-mono text-lg font-bold italic tracking-tighter">
            R$ {Number(secundario).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase italic">Saldo em Aberto</p>
          <p className="text-red-400 font-mono text-lg font-bold italic tracking-tighter">
            R$ {Number(saldoPagar).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
      </div>

    </div>
  );
}

export default function Conta() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const base_url = 'https://onboard.fck.ind.br';

  useEffect(() => {
    const token = localStorage.getItem('@user_token');
    if (!token) { setLoading(false); return; }

    fetch(`${base_url}/api/dashboard/financeiro/ContaPagar`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.ok ? res.json() : Promise.reject(res))
      .then(json => setData(Array.isArray(json) ? json[0] : json))
      .catch(err => console.error("Erro Financeiro:", err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="bg-[#161b22] border-l-4 border-yellow-500 p-5 rounded animate-pulse h-[180px]">
      <div className="h-4 bg-gray-800 rounded w-1/2 mb-4"></div>
      <div className="h-8 bg-gray-800 rounded w-3/4"></div>
    </div>
  );

  const aPagar = data?.aPagarMes || 0;
  const valorQuitado = data?.quitadosMes || 0;
  const saldoPagar = data?.aPagarMes - data?.quitadosMes || 0;
  const percentual = valorQuitado > 0 ? ((valorQuitado  / aPagar ) * 100).toFixed(0) : 0;

  return (
    <>
      <StatBox
        title="FLUXO DE CAIXA: PAGAMENTOS"
        icon={Wallet}
        color="text-yellow-500"
        border="border-yellow-500"
        principal={aPagar}
        secundario={valorQuitado}
        percentual={percentual}
        saldoPagar = {saldoPagar}
        onExpand={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <ContaPagarTotal
          data={data}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}